export enum PendingAccountType {
  LinkExistingAccounts = 0,
  OpenNewAccounts = 1,
}
